module.exports = __webpack_public_path__ + "static/SuisseIntl-Regular-87a83bb3be6fdd8905e96d6cd650107f.otf";